import { sendMessage } from '../services/sql-api';

export const fetchLineContextsForRecordings = async (
  recordingIds: Array<string>,
): Object => {
  const results = await sendMessage('detail', 'list', {
    entities: recordingIds,
    entityType: 'recording',
    returnEntityType: 'line_context',
  });

  let lineContextsByRecording = new Map();
  if (results && Array.isArray(results) && results.length > 0) {
    recordingIds.forEach((recordingId) => {
      const thumbnails = results.filter(
        (thumb) => thumb.recording_id === recordingId,
      );

      lineContextsByRecording.set(recordingId, thumbnails);
    });
  }

  return lineContextsByRecording;
};
